import React, { useEffect, useState } from 'react';

export default function BadgeLabel (props) {
  if (props.free === true) {
    return (
      <ul className='mb_label_w'>
        <React.Fragment key='0'>
          <li className='mb_label_free' title='무료'>
            FREE
          </li>
          &nbsp;
        </React.Fragment>
      </ul>
    );
  }

  return (
    <ul className='mb_label_w'>
      {(Array.isArray(props.data) ? props.data : [props.data]).map((item, index) => {
        let typeClassName = item.type === undefined ? '' : 'mb_label_' + item.type;
        let displayText = '';
        let labelTitle = '';

        switch (item.type) {
          case 'bora':
            displayText = '보라';
            labelTitle = '보는라디오';
            break;
          case 'free':
            typeClassName = 'mb_label_free';
            displayText = 'FREE';
            labelTitle = '무료';
            break;
          case '19':
            displayText = '19+';
            labelTitle = '19세 이상';
            break;
          case 'lowlatency':
            displayText = '저지연';
            labelTitle = '저지연';
            break;
          case 'multiaudio':
            displayText = '멀티 오디오';
            labelTitle = '멀티 오디오';
            break;
          default:
            break;
        }

        return (
          <React.Fragment key={index}>
            <li className={typeClassName} title={labelTitle}>
              {displayText}
            </li>
            &nbsp;
          </React.Fragment>
        );
      })}
    </ul>
  );
}
